export const GET_FORWARDED_TASKS = 'GET_FORWARDED_TASKS'
export const SUCCESS_FORWARDED_TASKS = 'SUCCESS_FORWARDED_TASKS'
export const FAILED_FORWARDED_TASKS = 'FAILED_FORWARDED_TASKS'